var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/qichejilingbujian/%E6%B1%BD%E8%BD%A6%E8%BD%AE%E6%AF%82%E6%94%BE%E5%A0%B5%E5%A4%B4%E5%B7%A5%E4%BD%9C%E7%AB%99.mp4",
                    'title':"视觉引导汽车轮毂放堵头",
                    'lable':"轮毂经由输送链条匀速移动至工业相机下方，通过视觉系统定位、识别、检测轮毂凹孔位置，并引导机器人从指定位置抓取堵头，跟踪放至凹孔中，依托负压检测机构，确保每一个凹孔准确投递，保证产品合格率。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度60次/min"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度达±0.3mm"
                        }
                    ]
                }
            ]
        },
        {
            'name':"并联机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/qichejilingbujian/%E6%B1%BD%E8%BD%A6%E8%BD%AE%E6%AF%82%E6%94%BE%E5%A0%B5%E5%A4%B4%E5%B7%A5%E4%BD%9C%E7%AB%99.mp4",
                    'title':"汽车轮毂放堵头工作站",
                    'lable':"轮毂经由输送链条匀速移动至工业相机下方，通过视觉系统定位、识别、检测轮毂凹孔位置，并引导机器人从指定位置抓取堵头，跟踪放至凹孔中，依托负压检测机构，确保每一个凹孔准确投递，保证产品合格率。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度60个/min/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.3mm"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工1人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升50%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期18个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"自动上轮毂"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人追踪放置"
                        },
                        {
                            'icon':"/static/case/cl.png",
                            'title':"组装完成"
                        },
                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/qichejilingbujian/%E6%B1%BD%E8%BD%A6%E4%BB%AA%E8%A1%A8%E5%8F%B0%E6%8F%92%E5%8D%A1%E6%89%A3%E5%B7%A5%E4%BD%9C%E7%AB%99%20.mp4",
                    'title':"汽车仪表台插卡扣工作站",
                    'lable':"仪表台经移载工装旋转至指定角度，卡扣通过震动盘输送至固定位置，由机器人定点抓取放置对应孔位中，单角度全部扣入完成后，由工装夹持仪表盘旋转至下一角度，单道工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度60次/分钟/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.2mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"角度±0.1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/yz.png",
                            'title':"仪表台移载"
                        },
                        {
                            'icon':"/static/case/ll.png",
                            'title':"振动盘上料"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人定抓定放"
                        },
                        {
                            'icon':"/static/case/cl.png",
                            'title':"组装完成"
                        },
                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/qichejilingbujian/%E5%8F%91%E5%8A%A8%E6%9C%BA%E6%B2%B9%E5%BA%95%E5%A3%B3%E6%8F%92%E9%94%80%E5%B7%A5%E4%BD%9C%E7%AB%99%20.mp4",
                    'title':"发动机油底壳插销工作站",
                    'lable':"汽车油底壳经输送工装输送至机器人下方，插销同步由振动盘输送至固定位置，通过视觉系统定位、识别、检测、传送信号至机器人，机器人从该固定位置抓取插销装入油底壳对应孔位，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度70次/分钟/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.05mm"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升50%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期15个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/yz.png",
                            'title':"工作台移载"
                        },
                        {
                            'icon':"/static/case/ll.png",
                            'title':"振动盘上料"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人定抓定放"
                        },
                        {
                            'icon':"/static/case/cl.png",
                            'title':"组装完成"
                        },
                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/qichejilingbujian/%E6%B1%BD%E8%BD%A6%E7%8E%BB%E7%92%83%E9%AB%98%E7%B2%BE%E6%90%AC%E8%BF%90%E5%8D%95%E5%85%83%20.mp4",
                    'title':"汽车玻璃高精搬运单元",
                    'lable':"汽车玻璃经滚筒输送至工业相机下方，通过视觉系统定位、识别、检测、传送信号至机器人，机器人定点跟踪抓取，再由视觉二次定位进行位置纠偏后放入指定位置，自动化入炉完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度3片/秒/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.1mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"角度±0.2°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期18个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"玻璃输出"
                        },
                        {
                            'icon':"/static/case/xcjc.png",
                            'title':"视觉瑕疵检测并定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉二次定位修正"
                        },{
                            'icon':"/static/case/fz.png",
                            'title':"放入指定地点"
                        },
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/qichejilingbujian/%E6%B1%BD%E8%BD%A6%E5%9E%AB%E7%89%87%E6%94%B6%E7%89%87%E5%B7%A5%E4%BD%9C%E7%AB%99%20%20.mp4",
                    'title':"汽车垫片收片工作站",
                    'lable':"垫片经由冲压机输送至工业相机下方，通过视觉系统定位、识别、检测OK/NG垫片，并传送信号至机器人，机器人定点跟踪抓取，再由视觉二次定位，将合格物料放置固定位置；不合格物料剔除放置另一固定位置，自动化码放工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度100片/分钟/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±0.5mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"角度±0.5°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期13个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"冲压机出料"
                        },
                        {
                            'icon':"/static/case/xcjc.png",
                            'title':"视觉瑕疵检测并定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取"
                        },
                        {
                            'icon':"/static/case/sjdw.png",
                            'title':"视觉二次定位"
                        },{
                            'icon':"/static/case/fz.png",
                            'title':"放入指定地点"
                        },
                    ]
                },

                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/qichejilingbujian/%E6%B1%BD%E8%BD%A6%E9%9B%B6%E9%83%A8%E4%BB%B6%E5%85%A5%E7%A0%94%E7%A3%A8%E6%9C%BA.mp4",
                    'title':"汽车零部件入研磨机",
                    'lable':"汽车零部件经冲压机出料并输送至工业相机下方，通过视觉系统定位、识别、检测并由机器人对检测出的正面物件实行跟踪抓取，定点放至固定位置，自动化工序完成",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80件/分钟/台"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"精度±1mm"
                        },
                        {
                            'icon':"/static/case/xzjd.png",
                            'title':"角度±1°"
                        }
                        ,
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        }
                        ,
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期12个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"冲压机出料"
                        },
                        {
                            'icon':"/static/case/xcjc.png",
                            'title':"视觉瑕疵检测并定位"
                        },{
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"放入指定地点"
                        }
                    ]
                },
                
            ],
            
        },
       
    ],
    name:"汽车及零部件",
    title:"solutions",
    subtitle:"汽车及零部件应用案例",
    subinfo:"我们的应用案例包括为汽车行业提供物料搬运、零部件加工组装、焊接、上下料相关服务，助力汽车行业发展，提升汽车零部件加工、汽车组装生产线的生产效率。",
}

export default {
    industryInfo
  };    


// WEBPACK FOOTER //
// ./src/data/industryInfo/7.js